type ShelfValues = Record<string, unknown>;

/**
 * Sets every shelf's setback (its `*offset` field) to the given value, leaving
 * the rest of each shelf untouched.
 *
 * @param {ShelfValues[]} shelves Shelf fieldset values
 * @param {number} setBack Setback in mm
 * @return {ShelfValues[]} Shelves with the new setback
 */
export const resetShelfSetBacks = (
    shelves: ShelfValues[],
    setBack: number
): ShelfValues[] =>
    shelves.map((shelf) => {
        const offsetField = Object.keys(shelf).find((key) =>
            key.includes('offset')
        );

        return offsetField ? {...shelf, [offsetField]: setBack} : shelf;
    });
